module.exports = __webpack_public_path__ + "static/media/myAwesomeStudio.9ab99c34.webp";